import home from './src/home.vue'
import ScenicCarParkManagerView from './src/ScenicCarParkManage/ScenicCarParkManagerView.vue' //停车场设备列表
import ScenicCarParkManagerEdit from './src/ScenicCarParkManage/ScenicCarParkManagerEdit.vue' //停车场设备详情
import CarRecordListView from './src/CarParkRecord/CarRecordListView.vue' //过车记录查询
import CarParkFeeRecordView from './src/CarParkFeeRecord/CarParkFeeRecordView.vue' //缴费记录查询
import TrafficFlowAnalysis from './src/CarParkAnalysis/TrafficFlowAnalysis.vue' //缴费记录查询
import VehicleSourceAnalysis from './src/CarParkAnalysis/VehicleSourceAnalysis.vue' //缴费记录查询

let views = {
    home,
    ScenicCarParkManagerView,
    ScenicCarParkManagerEdit,
    CarRecordListView,
    CarParkFeeRecordView,
    TrafficFlowAnalysis,
    VehicleSourceAnalysis
};

export default views;